import { createSubscribableMutator } from '@famly/vet_apollo-utils_create-subscribable-mutator';
import { UpdateAbsenceSourcesMutation } from './update-absence-sources.mutation';
export const { useSubscribableMutation: useUpdateAbsenceSources, useSubscribeMutationResult: useUpdateAbsenceSourcesResult, } = createSubscribableMutator(UpdateAbsenceSourcesMutation);
